module.exports = __webpack_public_path__ + "static/media/toys.beb4b1ac.svg";